

 export const postArray=[
      {
        "id":1,
    "title":"",
      "author":"",
      "content":"",
      "upvote": 0,
      "downvote": 0,
      "img":"../img/movie1.jpeg"
    
    },

       {
        "id":2,
    "title":"",
      "author":"",
      "content":"",
      "upvote": 0,
      "downvote": 0
    
    },
       {
        "id":3,
    "title":"",
      "author":"",
      "content":"",
      "upvote": 0,
      "downvote": 0
    
    },
    {
        "id":4,
    "title":"",
      "author":"",
      "content":"",
      "upvote": 0,
      "downvote": 0
    
    },

]